import { useQuery } from '@tanstack/react-query';
import { useServicesContext } from '../../../contexts/ServicesContext';

enum CacheKey {
  TeamHealthMetricsQuery = 'TEAM_HEALTH_METRICS',
}

export const useGetTeamHealthMetricsQuery = (teamId: number) => {
  const { getTeamHealthMetrics } = useServicesContext();
  return useQuery({
    queryKey: [CacheKey.TeamHealthMetricsQuery, teamId],
    queryFn: () => getTeamHealthMetrics(teamId),
    refetchInterval: 60000,
    enabled: Boolean(teamId),
  });
};
